import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../FeatureFlags';
import { IControlledPermissionItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';

export enum LockUnlockPermissionsState {
  Locked,
  Unlocked,
  Mixed
}

export module LockStatusHelper {

  const whiteLockIconClasses: {[n: string]: string} = {
    'Locked': 'tb-white-icon-permissions-locked',
    'Unlocked': 'tb-white-icon-permissions-unlocked',
    'Mixed': 'tb-white-icon-permissions-mixed'
  };

  const grayLockIconClasses: {[n: string]: string} = {
    'Locked': 'tb-gray-icon-permissions-locked',
    'Unlocked': 'tb-gray-icon-permissions-unlocked',
    'Mixed': 'tb-gray-icon-permissions-mixed'
  };

  const lockMessage: {[n: string]: string} = {
    'Locked': 'lockPermissionsSource_currentlyLocked',
    'Unlocked': 'lockPermissionsSource_currentlyUnlocked',
    'Mixed': 'lockPermissionsSource_currentlyMixed'
  };

  const lockMessageReact: {[n: string]: () => string} = {
    'Locked': Messages.lockPermissionsSource_currentlyLocked,
    'Unlocked': Messages.lockPermissionsSource_currentlyUnlocked,
    'Mixed': Messages.lockPermissionsSource_currentlyMixed
  };

  const messageIconClass: {[n: string]: string} = {
    'Locked' : 'tb-gray-icon-permissions-locked',
    'Unlocked': 'tb-icon-info-no-hover',
    'Mixed' : 'tb-gray-icon-permissions-locked'
  };

  const lockStateMessageIconClass: {[n: string]: string} = {
    'Locked' : 'tb-gray-icon-permissions-locked',
    'Unlocked': 'tb-gray-icon-permissions-unlocked',
    'Mixed' : 'tb-gray-icon-permissions-mixed'
  };

  export function getCombinedStatusOfAllItems(lockStates: LockUnlockPermissionsState[]):
      LockUnlockPermissionsState {

    const mixedLockedState: boolean =
        lockStates.some((state: LockUnlockPermissionsState) => lockStates[0] !== state);

    return mixedLockedState ? LockUnlockPermissionsState.Mixed : lockStates[0];
  }

  export function getLockStatusOfAllContainers(containers: Set<IControlledPermissionItemInfo>):
      LockUnlockPermissionsState[] {

    return containers.map((container: any) => {
      return container.controlledPermissionsEnabled
        ? LockUnlockPermissionsState.Locked
        : LockUnlockPermissionsState.Unlocked;
    });
  }

  export function getWhiteLockIconClass(lockState: LockUnlockPermissionsState): string {
    return whiteLockIconClasses[LockUnlockPermissionsState[lockState]];
  }

  export function getGrayLockIconClass(lockState: LockUnlockPermissionsState): string {
    return grayLockIconClasses[LockUnlockPermissionsState[lockState]];
  }

  export function getMessageIconClass(lockState: LockUnlockPermissionsState): string {
    return messageIconClass[LockUnlockPermissionsState[lockState]];
  }

  export function getLockStateMessageIconClass(lockState: LockUnlockPermissionsState): string {
    return lockStateMessageIconClass[LockUnlockPermissionsState[lockState]];
  }

  export function getLockMessage(lockState: LockUnlockPermissionsState): string {
    if (FeatureFlags.permissionsDialogReact) {
      return lockMessageReact[LockUnlockPermissionsState[lockState]]();
    } else {
      return lockMessage[LockUnlockPermissionsState[lockState]];
    }
  }

  export function getLockState(containers: Set<IControlledPermissionItemInfo>): LockUnlockPermissionsState {
    return getCombinedStatusOfAllItems(getLockStatusOfAllContainers(containers));
  }

}
